import CoveragePackageAccidentInputs from './CoveragePackageAccidentInputs';
import CoveragePackageContentInput from './CoveragePackageContentInput';
import CoveragePackageCarInputs from './CoveragePackageCarInputs';

interface InputComponent {
    Component: React.ComponentType<{
        isLoading: boolean;
        setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
    }>;
    trackFormInputs?: string[];
}

const getCoveragePackageInput = (flavourName: string): InputComponent | undefined => {
    switch (flavourName) {
        case 'Ulykkesforsikring':
        case 'Ulykkesforsikring til unge':
        case 'Børneforsikring':
            return {
                Component: CoveragePackageAccidentInputs,
                trackFormInputs: ['insuranceSum']
            };
        case 'Indboforsikring':
        case 'Indboforsikring til unge':
            return {
                Component: CoveragePackageContentInput,
                trackFormInputs: ['contentAndBaggageCovDeductible']
            };
        case 'Bilforsikring':
            return {
                Component: CoveragePackageCarInputs,
                trackFormInputs: ['deductible', 'yearlyMileage.displayName']
            };
        default:
            break;
    }
};

export default getCoveragePackageInput;
